import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appConstants from "../../../constants/appConstants";
import * as appHelper from '../../../helpers/appHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as animationHelper from "../../../helpers/animationHelper";

class ProducerNotes extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            producer_notes_label: appHelper.getLocaleString("producer_notes_label")
        };
        this.getImagePath = this.getImagePath.bind(this);
        this.show = this.show.bind(this);

        this.objectRef = React.createRef();
    }

    componentDidMount() {
        //this.show();
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                screen_not_ready_label: appHelper.getLocaleString("producer_notes_label")
            });
        }
    }

    componentDidUpdate() {

    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    show() {
        let objectRef = this.feedbackPanel.objectRef;
        let params = {
            ele: objectRef,
            duration: objectConstants.SHOW_PANEL_DURATION,
            delay: 0,
            callback: null
        };
        animationHelper.showHeight(params);
    }

    render() {
        return (
            <div className={`a-c`} ref={this.objectRef}>
                <div className={`object-container`}  style={{width: `100%`}}>
                    <div className="producer-notes">
                        <h4 className="producer-notes-title">{this.state.producer_notes_label}</h4>
                        {this.props.notes.map(note =>
                            <div className="producer-notes-description" key={note.screen_id} dangerouslySetInnerHTML={{__html: note.notes}} />
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

ProducerNotes.propTypes = {
    notes: PropTypes.array.isRequired,
    screen_id: PropTypes.number.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

ProducerNotes.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProducerNotes);



/** WEBPACK FOOTER **
 ** ./src/components/objects/producerNotes/ProducerNotes.js
 **/